// import React from "react";
// import { motion } from "framer-motion";

// const RINGS = [220, 170, 120, 70]; // fewer rings for a clean look
// const SIZE = 500;
// const CENTER = SIZE / 2;

// // Flag codes
// const FLAGS = ["us", "in", "ca", "ae", "za", "au", "gr"];

// function flagUrl(code, px = 64) {
//   const h = Math.round((px * 3) / 4);
//   return `https://flagcdn.com/${px}x${h}/${code}.png`;
// }

// function OrbitRing({ radius, flags, duration, direction }) {
//   const count = flags.length;
//   const angles = Array.from({ length: count }, (_, i) => (i * 360) / count);
//   const flagR = 18;

//   return (
//     <motion.g
//       animate={{ rotate: direction * 360 }}
//       transition={{ repeat: Infinity, ease: "linear", duration }}
//       style={{ transformOrigin: `${CENTER}px ${CENTER}px` }}
//     >
//       {/* orbit stroke */}
//       <circle
//         cx={CENTER}
//         cy={CENTER}
//         r={radius}
//         fill="none"
//         stroke="#e5e7eb"
//         strokeWidth={1}
//       />

//       {/* flags */}
//       {angles.map((deg, i) => {
//         const rad = (deg * Math.PI) / 180;
//         const x = CENTER + radius * Math.cos(rad);
//         const y = CENTER + radius * Math.sin(rad);
//         return (
//           <g key={i} transform={`translate(${x}, ${y})`}>
//             <g transform={`translate(${-flagR}, ${-flagR})`}>
//               <defs>
//                 <clipPath id={`clip-${radius}-${i}`}>
//                   <circle cx={flagR} cy={flagR} r={flagR} />
//                 </clipPath>
//               </defs>
//               <image
//                 href={flagUrl(flags[i])}
//                 width={flagR * 2}
//                 height={flagR * 2}
//                 clipPath={`url(#clip-${radius}-${i})`}
//                 preserveAspectRatio="xMidYMid slice"
//               />
//               <circle
//                 cx={flagR}
//                 cy={flagR}
//                 r={flagR}
//                 fill="none"
//                 stroke="white"
//                 strokeWidth={2}
//               />
//             </g>
//           </g>
//         );
//       })}
//     </motion.g>
//   );
// }

// export default function MapSvg() {
//   return (
//     <div className="w-full flex items-center justify-center py-10">
//       <div className="relative w-full aspect-[2/1] flex items-center justify-center">
//         <svg
//           viewBox={`0 0 ${SIZE} ${SIZE}`}
//           width="100%"
//           height="100%"
//           className="absolute inset-0"
//         >
//           <OrbitRing
//             radius={220}
//             flags={["us", "in", "ca", "ae", "za", "au", "gr"]}
//             duration={40}
//             direction={1}
//           />
//           <OrbitRing
//             radius={170}
//             flags={["in", "ca", "us", "za", "ae"]}
//             duration={30}
//             direction={-1}
//           />
//           <OrbitRing
//             radius={120}
//             flags={["us", "ca", "in"]}
//             duration={20}
//             direction={1}
//           />
//           <OrbitRing
//             radius={300}
//             flags={["us", "ca", "in"]}
//             duration={20}
//             direction={1}
//           />
//         </svg>

//         {/* Center content */}
//         <div className="relative text-center px-6 py-6 
//                 bg-white/50 backdrop-blur-xl 
//                 rounded-2xl shadow-xl 
//                 max-w-lg mx-auto">
//   <h2 className="text-2xl md:text-3xl font-extrabold mb-3 text-gray-900">
//     Your Wings, Your Destination
//   </h2>
//   <p className="text-gray-700 leading-relaxed">
//     With MH Cockpit, your pilot career can begin in 
//     <span className="font-semibold text-gray-900"> India</span>, 
//     <span className="font-semibold text-gray-900"> Canada</span>, or 
//     <span className="font-semibold text-gray-900"> the USA</span>
//     —the choice is yours.
//   </p>
// </div>
//       </div>
//     </div>
//   );
// }




// import React from "react";
// import { motion } from "framer-motion";

// const RINGS = [450, 350, 250, 120]; // keep 3 clean concentric orbits
// const SIZE = 500;
// const CENTER = SIZE / 2;

// // Flag codes
// function flagUrl(code, px = 64) {
//     const h = Math.round((px * 3) / 4);
//     return `https://flagcdn.com/${px}x${h}/${code}.png`;
// }

// function OrbitRing({ radius, flags, duration, direction }) {
//     const count = flags.length;
//     const angles = Array.from({ length: count }, (_, i) => (i * 360) / count);
//     const flagR = 18;

//     return (
//         <motion.g
//             animate={{ rotate: direction * 360 }}
//             transition={{ repeat: Infinity, ease: "linear", duration }}
//             style={{ transformOrigin: `${CENTER}px ${CENTER}px` }}
//         >
//             {/* orbit stroke */}
//             <circle
//                 cx={CENTER}
//                 cy={CENTER}
//                 r={radius}
//                 fill="none"
//                 stroke="#e5e7eb"
//                 strokeWidth={1}
//             />

//             {/* flags */}
//             {angles.map((deg, i) => {
//                 const rad = (deg * Math.PI) / 180;
//                 const x = CENTER + radius * Math.cos(rad);
//                 const y = CENTER + radius * Math.sin(rad);
//                 return (
//                     <g key={i} transform={`translate(${x}, ${y})`}>
//                         <g transform={`translate(${-flagR}, ${-flagR})`}>
//                             <defs>
//                                 <clipPath id={`clip-${radius}-${i}`}>
//                                     <circle cx={flagR} cy={flagR} r={flagR} />
//                                 </clipPath>
//                             </defs>
//                             <image
//                                 href={flagUrl(flags[i])}
//                                 width={flagR * 2}
//                                 height={flagR * 2}
//                                 clipPath={`url(#clip-${radius}-${i})`}
//                                 preserveAspectRatio="xMidYMid slice"
//                             />
//                             <circle
//                                 cx={flagR}
//                                 cy={flagR}
//                                 r={flagR}
//                                 fill="none"
//                                 stroke="white"
//                                 strokeWidth={2}
//                             />
//                         </g>
//                     </g>
//                 );
//             })}
//         </motion.g>
//     );
// }

// export default function MapSvg() {
//     return (
//         <div className="relative w-full flex items-center justify-center py-10 overflow-hidden z-0">
//             <div className="relative w-full max-sm:h-96 aspect-[2/1] max-sm:aspect-square flex items-center justify-center">
//                 {/* Animated Orbits */}
//                 <svg
//                     viewBox={`0 0 ${SIZE} ${SIZE}`}
//                     width="100%"
//                     height="100%"
//                     className="absolute inset-0"
//                 >
//                     <OrbitRing
//                         radius={450}
//                         flags={["us", "in", "ca", "ae", "za", "au", "gr"]}
//                         duration={40}
//                         direction={-1}
//                     />
//                     <OrbitRing
//                         radius={350}
//                         flags={["us", "in", "ca", "ae", "za", "au", "gr"]}
//                         duration={40}
//                         direction={1}
//                     />
//                     <OrbitRing
//                         radius={250}
//                         flags={["in", "ca", "us", "za", "ae"]}
//                         duration={30}
//                         direction={-1}
//                     />
//                     <OrbitRing
//                         radius={120}
//                         flags={["us", "ca", "in"]}
//                         duration={20}
//                         direction={1}
//                     />
//                 </svg>

//                 {/* Center content */}
//                 <div
//                     className="relative text-center px-6 max-sm:px-5 py-6 max-sm:py-5 
//                      bg-white/50 backdrop-blur-xl 
//                      rounded-2xl shadow-xl 
//                      max-w-lg mx-auto max-sm:mx-5 z-50"
//                 >
//                     <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold mb-3 text-gray-900">
//                         Your Wings, Your Destination
//                     </h2>
//                     <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
//                         {/* With MH Cockpit, your pilot career can begin in
//                         <span className="font-semibold text-gray-900"> India</span>,
//                         <span className="font-semibold text-gray-900"> Canada</span>, or
//                         <span className="font-semibold text-gray-900"> the USA </span>
//                         the choice is yours. */}
//                         With MH Cockpit, your pilot career can begin in India, Canada, or the USA the choice is yours.
//                     </p>
//                 </div>

//                 {/* Top faded overlay */}
//                 {/* <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-white to-transparent pointer-events-none z-20" /> */}

//                 {/* Bottom faded overlay */}
//                 <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-white to-transparent pointer-events-none z-20" />
//             </div>
//         </div>
//     );
// }





import React from "react";
import { motion } from "framer-motion";

// const RINGS = [450, 350, 250, 120];
const SIZE = 500;
const CENTER = SIZE / 2;

function flagUrl(code, px = 64) {
  const h = Math.round((px * 3) / 4);
  return `https://flagcdn.com/${px}x${h}/${code}.png`;
}

function OrbitRing({ radius, flags, duration, direction }) {
  const count = flags.length;
  const angles = Array.from({ length: count }, (_, i) => (i * 360) / count);
  const flagR = 18;

  return (
    <motion.g
      animate={{ rotate: direction * 360 }}
      transition={{ repeat: Infinity, ease: "linear", duration }}
      style={{ transformOrigin: `${CENTER}px ${CENTER}px` }}
    >
      {/* orbit stroke */}
      <circle
        cx={CENTER}
        cy={CENTER}
        r={radius}
        fill="none"
        stroke="#e5e7eb"
        strokeWidth={1}
      />

      {/* flags */}
      {angles.map((deg, i) => {
        const rad = (deg * Math.PI) / 180;
        const x = CENTER + radius * Math.cos(rad);
        const y = CENTER + radius * Math.sin(rad);
        return (
          <g key={i} transform={`translate(${x}, ${y})`}>
            <g transform={`translate(${-flagR}, ${-flagR})`}>
              <defs>
                <clipPath id={`clip-${radius}-${i}`}>
                  <circle cx={flagR} cy={flagR} r={flagR} />
                </clipPath>
              </defs>
              <image
                href={flagUrl(flags[i])}
                width={flagR * 2}
                height={flagR * 2}
                clipPath={`url(#clip-${radius}-${i})`}
                preserveAspectRatio="xMidYMid slice"
              />
              <circle
                cx={flagR}
                cy={flagR}
                r={flagR}
                fill="none"
                stroke="white"
                strokeWidth={2}
              />
            </g>
          </g>
        );
      })}
    </motion.g>
  );
}

export default function MapSvg() {
  return (
    <div className="relative w-full flex items-center justify-center py-6 overflow-hidden z-0">
      <div className="relative w-full max-w-6xl aspect-[2/1] max-sm:aspect-square flex items-center justify-center">
        {/* Animated Orbits */}
        <svg
          viewBox={`0 0 ${SIZE} ${SIZE}`}
          width="100%"
          height="100%"
          className="absolute inset-0"
        >
          <OrbitRing
            radius={450}
            flags={["us", "in", "ca", "ae", "za", "au", "gr"]}
            duration={40}
            direction={-1}
          />
          <OrbitRing
            radius={350}
            flags={["us", "in", "ca", "ae", "za", "au", "gr"]}
            duration={40}
            direction={1}
          />
          <OrbitRing
            radius={250}
            flags={["in", "ca", "us", "za", "ae"]}
            duration={30}
            direction={-1}
          />
          <OrbitRing
            radius={120}
            flags={["us", "ca", "in"]}
            duration={20}
            direction={1}
          />
        </svg>

        {/* Center content */}
        <div
          className="relative text-center px-6 max-sm:px-5 py-5 max-sm:py-4 
                     bg-white/50 backdrop-blur-xl 
                     rounded-2xl shadow-xl 
                     max-w-lg mx-auto max-sm:mx-5 z-50"
        >
          <h2 className="text-lg sm:text-2xl md:text-3xl font-extrabold mb-3 text-gray-900">
            Your Wings, Your Destination
          </h2>
          <p className="text-gray-700 leading-relaxed text-xs sm:text-base">
            With MH Cockpit, your pilot career can begin in India, Canada, or
            the USA  the choice is yours.
          </p>
        </div>

        {/* Bottom faded overlay */}
        <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-white to-transparent pointer-events-none z-20" />
      </div>
    </div>
  );
}
